import React, { useState, useEffect } from "react";
import { BaseModal } from "./BaseModal";
import { useStore } from "../../stores/store";
import { ModalKeys } from "../../interfaces/config";
import UserForm from "../Forms/UserForm";

export default function AddUserModal() {
  const { isActive, deactivateTool, createUser, isAdminModalLoading, config } =
    useStore();
  const [successAlertShown, setSuccessAlertShown] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [user, setUser] = useState({
    UserName: "",
    FirstName: "",
    LastName: "",
    Title: "",
    Agency: "",
    PhoneNumber: "",
    Email: "",
    Active: true,
    Roles: config?.authenticationService?.allowedUserRoles,
  });
  const resetUser = () => {
    setUser({
      UserName: "",
      FirstName: "",
      LastName: "",
      Title: "",
      Agency: "",
      PhoneNumber: "",
      Email: "",
      Active: true,
      Roles: config?.authenticationService?.allowedUserRoles,
    });
  };

  const onClose = () => {
    resetUser();
    deactivateTool(ModalKeys.ADD_USER);
  };

  const onAddUserClicked = () => {
    createUser(user);
    deactivateTool(ModalKeys.ADD_USER);
    setSuccessAlertShown(true);
    setTimeout(() => {
      setSuccessAlertShown(false);
    }, 5000);
  };

  return (
    <>
      <BaseModal active={isActive(ModalKeys.ADD_USER)} title="Add New User">
        <div className="p-3 font-helvetica text-sm">
          <UserForm
            setIsValid={setIsFormValid}
            user={user}
            setUser={setUser}
            isLoading={isAdminModalLoading}
          />
        </div>
        <div className="bg-[#f5f5f5] border-t border-[#ddd] w-full text-right p-1">
          <button
            disabled={isAdminModalLoading || !isFormValid}
            onClick={onAddUserClicked}
            className={`btn btn-secondary btn-sm mr-1 ${
              !isFormValid ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            Add User
          </button>
          <button onClick={resetUser} className="btn btn-secondary btn-sm mr-1">
            Reset
          </button>
          <button onClick={onClose} className="btn btn-secondary btn-sm">
            Cancel
          </button>
        </div>
      </BaseModal>
      {successAlertShown && (
        <div className="absolute top-0 w-full text-center transition-all">
          <div role="alert" className="alert alert-success w-96 m-auto">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 shrink-0 stroke-current"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span>Successfully created new user: {user.UserName}</span>
          </div>
        </div>
      )}
    </>
  );
}
